import { canSubmitProject } from '@shootsta/contract-and-credit-utilities';
import canSubmitProjectFromLedger from './canSubmitProjectFromLedger';

// Single decision point for "can this user submit/create a project".
// Picks the finance-ledger gate or the legacy contract/credit gate based on
// the flag, so the branch lives in one place instead of every consumer.
// Synchronous: both gates return a boolean, so this is safe to call in render.
export default function resolveCanSubmit({
  financeLedgerEnabled,
  // ledger gate
  isUnlimited,
  creditType,
  selectedTeamId,
  financeBalance,
  creditCost,
  // Create gate opens on any team or the pool; submit gate keys off the team.
  teamAgnostic,
  // legacy gate
  teamCreditInfo,
  orgCreditInfo,
  isNewSubscriptionModelEnabled
}) {
  if (financeLedgerEnabled) {
    return canSubmitProjectFromLedger({
      isUnlimited,
      creditType,
      selectedTeamId,
      financeBalance,
      creditCost,
      teamAgnostic
    });
  }

  return canSubmitProject({
    teamCreditInfo,
    orgCreditInfo,
    selectedTeamId,
    creditCost,
    isNewSubscriptionModelEnabled
  });
}
